<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="
				c-portlet__header
				o-stack o-stack--center o-stack--splitted
				u-border-bottom u-px-small u-py-mini
				c-portlet-gap
			"
		>
			<div class="daypart-section-title primary-color">{{ sectiontitle }} {{ timezone }}</div>
		</div>
		<div class="analytics-portlet-content daypart-portlet-content r11-daypart-chart" style="position: relative">
			<div class="o-stack o-stack--nowrap o-stack--center daypart-div" *ngIf="hasData">
				<div class="chart-div">
					<app-donut
						class="chartelement"
						(hightLightLabels)="hightLightLabels($event)"
						[chartConfigurationObj]="chartConfigObj"
						[chartData]="daypartChartObjArray[0]?.chartObj"
					>
					</app-donut>
					<div class="chartDateRange">{{ startDate }} - {{ endDate }}</div>
				</div>
				<div class="table-div">
					<ngx-datatable
						class="datatable daypart-chart-legend"
						[rows]="daypartChartObjArray[0]?.chartObj"
						[cssClasses]="cssClasses"
						[columnMode]="'force'"
						[headerHeight]="50"
						[footerHeight]="footerHeight"
						[rowHeight]="rowHeight"
						[reorderable]="reorderable"
						[scrollbarV]="isVerticalScrollable"
					>
						<ngx-datatable-column
							name="Time of Day"
							[resizeable]="false"
							prop="name"
							[cellClass]="'dayparts-cell'"
							[headerClass]="'dayparts-header'"
						>
							<ng-template let-row="row" let-rowIndex="i" let-value="value" ngx-datatable-cell-template>
								<span class="daypartRow">
									<span
										class="dots"
										[ngStyle]="{ background: row.color }"
										[ngClass]="{ 'highlight-dark': row.isHighlighted }"
										[title]="getTitle(row.name, row.dayparttime)"
									></span>
									<span class="daypartName">{{ row.name }}</span>
								</span>
							</ng-template>
						</ngx-datatable-column>
						<ngx-datatable-column
							[name]="'Impressions'"
							[resizeable]="false"
							prop="y"
							[cellClass]="'impressions-cell'"
							[headerClass]="'impressions-header'"
						>
							<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
								<span class="impressions">{{ row.y | number }}</span>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData" style="height: 350px">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
